export function Phone2Icon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="29"
      fill="none"
      viewBox="0 0 19 29"
      className={className}
    >
      <path
        fill="#fff"
        fillOpacity=".2"
        d="M9.805 1a6 6 0 0 0-.73 2.053H5.173c-.325 0-.636.13-.865.363a1.25 1.25 0 0 0 0 1.754c.23.232.54.363.865.363h4.025A6.002 6.002 0 0 0 18 9.195v16.083c0 .985-.385 1.93-1.071 2.628A3.65 3.65 0 0 1 14.339 29H3.66a3.65 3.65 0 0 1-2.589-1.094A3.75 3.75 0 0 1 0 25.278V4.722c0-.985.385-1.93 1.071-2.628A3.65 3.65 0 0 1 3.661 1zm.664 24.099H7.643a1.2 1.2 0 0 0-.94.316 1.24 1.24 0 0 0-.4.918 1.25 1.25 0 0 0 .4.918 1.22 1.22 0 0 0 .94.316h2.826a1.2 1.2 0 0 0 .94-.316 1.24 1.24 0 0 0 .4-.918 1.25 1.25 0 0 0-.4-.918 1.22 1.22 0 0 0-.94-.316M15 0a4 4 0 1 1 0 8 4 4 0 0 1 0-8"
      />
      <path
        fill="url(#b)"
        fillOpacity=".3"
        d="M9.805 1a6 6 0 0 0-.73 2.053H5.173c-.325 0-.636.13-.865.363a1.25 1.25 0 0 0 0 1.754c.23.232.54.363.865.363h4.025A6.002 6.002 0 0 0 18 9.195v16.083c0 .985-.385 1.93-1.071 2.628A3.65 3.65 0 0 1 14.339 29H3.66a3.65 3.65 0 0 1-2.589-1.094A3.75 3.75 0 0 1 0 25.278V4.722c0-.985.385-1.93 1.071-2.628A3.65 3.65 0 0 1 3.661 1zm.664 24.099H7.643a1.2 1.2 0 0 0-.94.316 1.24 1.24 0 0 0-.4.918 1.25 1.25 0 0 0 .4.918 1.22 1.22 0 0 0 .94.316h2.826a1.2 1.2 0 0 0 .94-.316 1.24 1.24 0 0 0 .4-.918 1.25 1.25 0 0 0-.4-.918 1.22 1.22 0 0 0-.94-.316M15 0a4 4 0 1 1 0 8 4 4 0 0 1 0-8"
      />
      <path
        fill="url(#c)"
        d="M9.805 1a6 6 0 0 0-.73 2.053H5.173c-.325 0-.636.13-.865.363a1.25 1.25 0 0 0 0 1.754c.23.232.54.363.865.363h4.025A6.002 6.002 0 0 0 18 9.195v16.083c0 .985-.385 1.93-1.071 2.628A3.65 3.65 0 0 1 14.339 29H3.66a3.65 3.65 0 0 1-2.589-1.094A3.75 3.75 0 0 1 0 25.278V4.722c0-.985.385-1.93 1.071-2.628A3.65 3.65 0 0 1 3.661 1zm.664 24.099H7.643a1.2 1.2 0 0 0-.94.316 1.24 1.24 0 0 0-.4.918 1.25 1.25 0 0 0 .4.918 1.22 1.22 0 0 0 .94.316h2.826a1.2 1.2 0 0 0 .94-.316 1.24 1.24 0 0 0 .4-.918 1.25 1.25 0 0 0-.4-.918 1.22 1.22 0 0 0-.94-.316M15 0a4 4 0 1 1 0 8 4 4 0 0 1 0-8"
      />

      <defs>
        <linearGradient
          id="b"
          x1="15.365"
          x2="-4.796"
          y1="29"
          y2="20.846"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity="0" />
          <stop offset=".5" stopColor="#fff" stopOpacity=".2" />
          <stop offset="1" stopColor="#fff" />
        </linearGradient>
        <linearGradient id="c" x1="0" x2="19" y1="14.5" y2="14.5" gradientUnits="userSpaceOnUse">
          <stop stopColor="#21a038" />
          <stop offset="1" stopColor="#186d27" />
        </linearGradient>
        <clipPath id="a" transform="translate(4 4)">
          <path d="M9.805 1a6 6 0 0 0-.73 2.053H5.173c-.325 0-.636.13-.865.363a1.25 1.25 0 0 0 0 1.754c.23.232.54.363.865.363h4.025A6.002 6.002 0 0 0 18 9.195v16.083c0 .985-.385 1.93-1.071 2.628A3.65 3.65 0 0 1 14.339 29H3.66a3.65 3.65 0 0 1-2.589-1.094A3.75 3.75 0 0 1 0 25.278V4.722c0-.985.385-1.93 1.071-2.628A3.65 3.65 0 0 1 3.661 1zm.664 24.099H7.643a1.2 1.2 0 0 0-.94.316 1.24 1.24 0 0 0-.4.918 1.25 1.25 0 0 0 .4.918 1.22 1.22 0 0 0 .94.316h2.826a1.2 1.2 0 0 0 .94-.316 1.24 1.24 0 0 0 .4-.918 1.25 1.25 0 0 0-.4-.918 1.22 1.22 0 0 0-.94-.316M15 0a4 4 0 1 1 0 8 4 4 0 0 1 0-8" />
        </clipPath>
      </defs>
    </svg>
  );
}
